import React, { useEffect, useCallback, useState} from 'react';
import PendingComments from './PendingComments.js';
import {SEQUENCE_ANNOTATION} from 'constants/annotation-types.js';
import Comments from './Comments.js';
import ethereum from 'decentralized/ethereum.js';
import { Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import Colors from 'components/Colors.js';
import {connect} from 'react-redux';

const colors = new Colors();

const CommentsPane = ({
    worksLoaded,
    linkType=SEQUENCE_ANNOTATION
}) => { 
    const [comment, setComment] = useState('');
    const [pendingComments, setPendingComments] = useState([]);

    useEffect(() => {
        setPendingComments([]);
    }, [worksLoaded]);

    const submit = useCallback(() => {
        worksLoaded.map(
            ({newSequence}) =>
                ethereum.xanadu.newAnnotationContent(
                    linkType,
                    newSequence,
                    comment));

        setComment('');
        setPendingComments([
            ... pendingComments,
            comment
        ]);
    }, [
        worksLoaded,
        comment,
        setComment,
        pendingComments,
        setPendingComments
    ]);


    if (worksLoaded.length === 0) {
        return [];
    }

    return (
        <div className="comments-pane">
          <div className="work-comments">
            <Comments works={worksLoaded}/>
            <PendingComments pendingComments={pendingComments}/>
          </div>
          <Input
            type="textarea"
            value={comment}
            className="comment-text"
            placeholder="Write a comment here"
            onChange={(e) => setComment(e.target.value)}/>
          <div
            onClick={submit}
            className={
                comment === "" ?
                    "submit-comment-btn disabled" :
                    "submit-comment-btn"}>
            Send
          </div>
        </div>
    );
}

const WorksInfo = ({worksLoaded}) => {
    return (
        <div className="works-info">
          {worksLoaded.map(
              work =>
                  <div className="work-info">
                    <div
                      className="dot"
                      style={{
                        backgroundColor: colors.getColorForHash(work.newSequence)
                    }}/>
                    {work.title}
                  </div>)}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      worksLoaded: state.explore.worksLoaded
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentsPane);
